import ApprovedVideosQuery from '@/graphql/video/ApprovedVideosQuery.gql'
import ContentRejectReasonsQuery from '@/graphql/content/ContentRejectReasonsQuery.gql'
import ReviewBranding from '@/graphql/content/ReviewBranding.gql'
import ReviewVideo from '@/graphql/video/ReviewVideo.gql'
import S3UrlQuery from '@/graphql/content/S3UrlQuery.gql'
import UnreviewedImagesQuery from '@/graphql/image/UnreviewedImagesQuery.gql'
import UnreviewedVideosQuery from '@/graphql/video/UnreviewedVideosQuery.gql'

import apollo from '@/graphql'

// initial state
const state = {
  contentRejectReasons: [],
}

// getters
const getters = {
  contentRejectReasons: st => st.contentRejectReasons,
}

// mutations
const mutations = {
  setContentRejectReasons(st, contentRejectReasons) {
    state.contentRejectReasons = contentRejectReasons
  },
}

// actions
const actions = {
  getS3Url(context, { key }) {
    return apollo.defaultClient.query({
      query: S3UrlQuery,
      variables: { key },
    })
  },

  loadContentRejectReasons({ commit }) {
    apollo.defaultClient.watchQuery({
      query: ContentRejectReasonsQuery,
    }).subscribe(({ data: { contentRejectReasons } }) => {
      commit('setContentRejectReasons', contentRejectReasons)
    })
  },

  reviewBranding(context, {
    id, isApproved, contentRejectReasonsId,
  }) {
    apollo.defaultClient.mutate({
      mutation: ReviewBranding,
      variables: { id, isApproved, contentRejectReasonsId },
      refetchQueries: [{
        query: UnreviewedImagesQuery,
      }],
    })
  },

  reviewVideo(context, {
    id, isApproved, contentRejectReasonsId,
  }) {
    apollo.defaultClient.mutate({
      mutation: ReviewVideo,
      variables: { id, isApproved, contentRejectReasonsId },
      refetchQueries: [{
        query: ApprovedVideosQuery,
      }, {
        query: UnreviewedVideosQuery,
      }],
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/content/Content.js